import * as React from 'react';
import styled from 'styled-components';
import FlexSpacer from './FlexSpacer';

const Buttons = (props: Props) => {
	return (
		<Self centre={props.centre} left={props.left}>
			{!props.centre && !props.left && <FlexSpacer />}
			{props.children}
		</Self>
	);
};

interface Props {
	centre?: boolean;
	children: JSX.Element | JSX.Element[];
	left?: boolean;
}

Buttons.defaultProps = {
	centre: false,
	left: false
};

export default Buttons;

const Self = styled.section<{ centre: boolean; left: boolean }>`
	text-align: center;
	margin: 26px 0 0 0;
	${(props) => (props.centre ? `justify-content: center;` : 'display: flex;')}
	${(props) => (props.centre ? `justify-content: flex-start;` : '')}
`;
